export default {
      id: "icon-loop-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "icons.svg#icon-loop",
      toString: function () {
        return this.url;
      }
    }